'use client';

import { c as _c } from "react/compiler-runtime";
import * as Sentry from '@sentry/nextjs';
import { AlertTriangle } from 'lucide-react';
import { useEffect } from 'react';
import { PALETTE } from '@app/lib/palette';
export default function GlobalError(t0) {
  const $ = _c(21);
  const {
    error,
    reset
  } = t0;
  let t1;
  let t2;
  if ($[0] !== error) {
    t1 = () => {
      Sentry.captureException(error);
      Sentry.showReportDialog({
        title: "Fehler aufgetreten",
        subtitle: "Unser Team wurde benachrichtigt. Hilf uns, das Problem schneller zu beheben.",
        labelComments: "Was ist passiert?",
        labelClose: "Schlie\xDFen",
        labelSubmit: "Fehler melden",
        successMessage: "Danke f\xFCr Dein Feedback! Wir werden das Problem schnell beheben."
      });
    };
    t2 = [error];
    $[0] = error;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <style>{"\n                :root {\n                    --global-error-bg: #fffcf9;\n                    --global-error-text: #2d3436;\n                    --global-error-muted: #636e72;\n                    --global-error-faint: #b2bec3;\n                    --global-error-icon-bg: rgba(239,68,68,0.08);\n                    --global-error-icon-border: rgba(239,68,68,0.25);\n                    --global-error-icon: #ef4444;\n                    --global-error-btn-border: rgba(224,123,83,0.4);\n                }\n                @media (prefers-color-scheme: dark) {\n                    :root {\n                        --global-error-bg: #1a1a2e;\n                        --global-error-text: #e2e8f0;\n                        --global-error-muted: #a0aec0;\n                        --global-error-faint: #636e72;\n                        --global-error-icon-bg: rgba(239,68,68,0.15);\n                        --global-error-icon-border: rgba(248,113,113,0.35);\n                        --global-error-icon: #f87171;\n                        --global-error-btn-border: rgba(240,144,112,0.5);\n                    }\n                }\n            "}</style>;
    t4 = {
      margin: 0,
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "var(--global-error-bg, #fffcf9)",
      color: "var(--global-error-text, #2d3436)",
      fontFamily: "system-ui, sans-serif",
      textAlign: "center",
      padding: "2rem"
    };
    t5 = {
      width: "96px",
      height: "96px",
      borderRadius: "50%",
      backgroundColor: "var(--global-error-icon-bg)",
      border: "2px solid var(--global-error-icon-border)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "1.5rem"
    };
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  let t7;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div style={t5}><AlertTriangle style={{
        width: "40px",
        height: "40px",
        color: "var(--global-error-icon)"
      }} /></div>;
    t7 = <h1 style={{
      fontSize: "clamp(1.5rem, 4vw, 2.5rem)",
      fontWeight: 800,
      marginBottom: "0.75rem",
      lineHeight: 1.15
    }}>Kritischer Fehler</h1>;
    t8 = <p style={{
      fontSize: "1rem",
      color: "var(--global-error-muted)",
      maxWidth: "380px",
      lineHeight: 1.65,
      marginBottom: "2rem"
    }}>Ein schwerwiegender Fehler ist aufgetreten. Das Team wurde benachrichtigt.</p>;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== error.digest) {
    t9 = error.digest && <p style={{
      fontSize: "0.7rem",
      color: "var(--global-error-faint)",
      fontFamily: "monospace",
      marginBottom: "2rem"
    }}>ID: {error.digest}</p>;
    $[9] = error.digest;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      display: "flex",
      gap: "0.75rem",
      flexWrap: "wrap",
      justifyContent: "center"
    };
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      padding: "0.65rem 1.4rem",
      borderRadius: "999px",
      backgroundColor: PALETTE.orange,
      color: "white",
      fontWeight: 600,
      fontSize: "0.9rem",
      border: "none",
      cursor: "pointer"
    };
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== reset) {
    t12 = <button onClick={reset} style={t11}>Erneut versuchen</button>;
    $[13] = reset;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <a href="/" style={{
      display: "inline-flex",
      alignItems: "center",
      padding: "0.65rem 1.4rem",
      borderRadius: "999px",
      border: "1.5px solid var(--global-error-btn-border)",
      color: PALETTE.orange,
      fontWeight: 600,
      fontSize: "0.9rem",
      textDecoration: "none"
    }}>Zur Startseite</a>;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t12) {
    t14 = <div style={t10}>{t12}{t13}</div>;
    $[16] = t12;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== t14 || $[19] !== t9) {
    t15 = <html lang="de">{t3}<body style={t4}>{t6}{t7}{t8}{t9}{t14}</body></html>;
    $[18] = t14;
    $[19] = t9;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  return t15;
}